<template>
  <div class="home">
    <van-nav-bar
      placeholder
      fixed
      border
      left-arrow
      safe-area-inset-top
      left-text="班车服务大厅"
      @click-left="onBackClick"
    />
    <div class="home-page-container">
    <!-- <van-search v-model="searchValue"
                  class="home-page-search"
                 placeholder="请输入站点名称搜索"
                  style="z-index: 100"
                  show-action
                  @search="onSearch"
                  @cancel="onCancel"/>-->

 <div class="filter-bar-wrapper">
        <div class="filter-row">
          <div class="label" style="color: #969799;">
            始末站：
          </div>
          <div class="value" @click="addressSelectShow = true">
            {{ addressName }}
            <van-icon name="arrow-down" />
          </div>
        </div>
           <van-dialog v-model:show="addressSelectShow" 
           title="请选择始末站" 
           show-cancel-button
           confirmButtonColor="#196c44"
           :beforeClose="addressBeforeClose"
           @confirm='addressConfirm'
           >
              
              <van-radio-group v-model="addressSelect">
                <van-radio name="中关村校区->良乡校区">中关村校区->良乡校区</van-radio>
                <van-radio name="良乡校区->中关村校区">良乡校区->中关村校区</van-radio>
                <van-radio name="中关村校区->西山校区">中关村校区->西山校区</van-radio>
                <van-radio name="西山校区->中关村校区">西山校区->中关村校区</van-radio>

                <van-radio name="中关村校区->回龙观">中关村校区->回龙观</van-radio>
                <van-radio name="回龙观->中关村校区">回龙观->中关村校区</van-radio>
                <van-radio name="中关村校区->房山分校阎村">中关村校区->房山分校阎村</van-radio>
                <van-radio name="房山分校阎村->中关村校区">房山分校阎村->中关村校区</van-radio>
                <van-radio name="良乡校区->回龙观">良乡校区->回龙观</van-radio>
                <van-radio name="回龙观->良乡校区">回龙观->良乡校区</van-radio>
                </van-radio-group>
          </van-dialog>

      </div>


      <div class="filter-bar-wrapper">
        <div class="filter-row">
          <div class="label" style="color: #969799;">
            日期：
          </div>
          <div class="value">
            {{ parseTime(currentDate) }} {{ weekTime(currentDate)}}
          </div>
        </div>
        <!-- <van-popup v-model="dateSelectShow"
                   get-container="body"
                   position="bottom">
          <van-datetime-picker
            :value="currentDate"
            type="date"
            title="选择日期"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :swipe-duration="100"
            ref="timePicker"
            @confirm="onDateConfirm"
            @cancel="dateSelectShow = false"
            @change ='onDateChage'
          />
        </van-popup> -->
      </div>
      <div class="home-page-content-wrapper">
        <div class="pulldown-bswrapper" ref="bsWrapper">
          <div class="pulldown-scroller">
            <div class="pulldown-wrapper">
              <div v-show="beforePullDown">
                <span>下拉刷新</span>
              </div>
              <div v-show="!beforePullDown">
                <div v-show="isPullingDown">
                  <span>加载中...</span>
                </div>
                <div v-show="!isPullingDown">
                  <span>刷新成功</span>
                </div>
              </div>
            </div>
            <div class="list-wrapper tabbar-bottom-area pulldown-list">
              <cart-repair v-for="(item, index) in list"
                         :key="index"
                         :info="item"
                         @click="onCardClick(item)"></cart-repair>
              <van-empty image="default" description="没有车次" v-if="list.length === 0" />
            </div>
            <div class="pullup-tips" v-if="pagination.page > 1">
              <div v-if="!isPullUpLoad" class="before-trigger">
                <span class="pullup-txt">上拉刷新</span>
              </div>
              <div v-else class="after-trigger">
                <span class="pullup-txt">加载中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';
import moment from 'moment';
import { Toast,RadioGroup, Radio } from 'vant';
import CartCard from '@/components/home/CartCard.vue';
import CartRepair from '@/components/home/CartRepair.vue';
import Trains from '@/apis/Trains';


BScroll.use(PullDown);
BScroll.use(PullUp);

// eslint-disable-next-line no-unused-vars
const TIME_BOUNCE = 800;
// eslint-disable-next-line no-unused-vars
const REQUEST_TIME = 1000;
const THRESHOLD = 70;
const STOP = 56;
// eslint-disable-next-line no-unused-vars
const STEP = 0;

export default {
  name: 'Home',
  components: {
    // CartCard,
	CartRepair
  },
  mounted() {
    
    this.fetchList();
    this.$nextTick(() => {
      this.initScroll();
    });

    
    
  },
  data() {
    return {
      dateSelectShow: false,
      addressSelectShow:false,
      addressName:'请选择始末站',
      addressSelect:'',
      value1: 0,
      option1: [
        { text: '筛选', value: 0 },
      ],
      value2: 0,
      option2: [
        { text: '日期', value: 0 },
      ],
      searchValue: '',
      beforePullDown: true,
      isPullingDown: false,
      bscroll: undefined,
      isPullUpLoad: false,
      list: [],
      currentDate: new Date(),
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
      },
      datechageTime:'',
      weekArr:["星期日", "星期一", "星期二", "星期三", "星期四","星期五", "星期六"]
    };
  },
  created(){
    this.addressSelect = this.$store.state.addressSelect || '';
    this.addressName = this.addressSelect;
    if(!this.addressSelect){
    this.addressSelectShow =true;
    }
  },
  computed: {
    // currentDate() {
    //   return this.$store.state.currentDate;
    // },
   
    minDate() {
      return moment().toDate();
    },
    maxDate() {
      return moment().add(6, 'days').toDate();
    },
  },
  methods: {
    parseTime(d) {
      return moment(d).format('YYYY年MM月DD日');
    },
    weekTime(d) {

       var day = new Date(moment(d).format('YYYY-MM-DD'));

       var wk = day.getDay();
       return this.weekArr[wk];
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      }
      if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    addressBeforeClose(action,done){

          if(action ==='confirm'  && this.addressSelect === ''){
            Toast.fail('请选择始末站');
            return  done(false);
          }

          return done();
    },
   async  addressConfirm(){
     this.addressSelectShow=false;
         this.addressName = this.addressSelect;
       this.$store.commit('updateAddress', this.addressSelect);
      this.dateSelectShow = false;
      const toast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.pagination.page = 1;
      await this.fetchList();
      toast.clear();
    },
    async onDateConfirm(value) {
      // this.currentDate = value;
     
      this.$store.commit('updateCurrentDate', this.datechageTime);
      this.dateSelectShow = false;
      const toast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      await this.fetchList();
      toast.clear();
    },
    onDateChage(e){
    
     
      let timeArr = e.getValues();
      let chageTime = new Date(Date.parse(timeArr[0]+'/'+timeArr[1].replace('月','')+'/'+timeArr[2].replace('日','')));
          this.datechageTime = chageTime;
    },
    sure () { 
      this.$refs.timePicker.getPicker().confirm() 
      },
    onBackClick() {
      this.$router.replace('/');
    },
    onCardClick(item) {
      console.log('Card click ---> ', item);
    },
    onSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    onCancel() {
      this.searchValue = '';
      this.pagination.page = 1;
      this.fetchList();
    },
    async fetchList() {
      const { page, limit } = this.pagination;
     
      const params = {
        page,
        limit,
        date: moment(this.currentDate).format('YYYY-MM-DD'),
        address:this.addressSelect
      };
      if (this.searchValue) {
        params.name = this.searchValue;
      }
      console.log('列表参数》》》', params);
      const res = await Trains.getBpList(params);
      if (Number(res.code) === 0) {
        this.pagination.total = res?.count || 0;
        if (page === 1) {
          this.list = res?.data;
        } else {
          this.list.push(...res?.data);
        }
      }
    },
    initScroll() {
      this.bscroll = new BScroll(this.$refs.bsWrapper, {
        pullUpLoad: true,
        scrollY: true,
        click: true,
        taps: true,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP,
        },
      });
      this.bscroll.on('pullingDown', this.pullingDownHandler);
      this.bscroll.on('pullingUp', this.pullingUpHandler);
    },
    async pullingDownHandler() {
      console.log('trigger pullDown');
      this.beforePullDown = false;
      this.isPullingDown = true;
      this.pagination.page = 1;
      // STEP += 1;

      await this.fetchList();

      this.isPullingDown = false;
      await this.finishPullDown();
    },
    async finishPullDown() {
      this.bscroll.finishPullDown();
      setTimeout(() => {
        this.beforePullDown = true;
        this.bscroll.refresh();
      }, TIME_BOUNCE + 100);
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true;
      if (this.pagination.page * this.pagination.limit < this.pagination.total) {
        this.pagination.page += 1;
        await this.fetchList();
      }
      this.bscroll.finishPullUp();
      this.bscroll.refresh();
      this.isPullUpLoad = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";
@import "~@/assets/styles/variable.scss";
.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}
.pulldown-bswrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .pulldown-wrapper {
    position: absolute;
    width: 100%;
    padding: 1.42rem;
    box-sizing: border-box;
    transform: translateY(-100%) translateZ(0);
    text-align: center;
    color: #999;
  }

  .pullup-tips {
    color: #999;
    text-align: center;
    padding: 20px;
  }
}

.list-wrapper {
  padding-top: 0.7rem;
  box-sizing: border-box;
  flex-grow: 1;
  height: 100%;
  /*overflow: auto;*/
}

::v-deep .van-nav-bar__text {
  color: #fff;
}

.home-page-container {
  height: calc(100vh - 46px - 50px);
  display: flex;
  flex-direction: column;
}

.home-page-search {
  flex-shrink: 0;
}

.home-page-content-wrapper {
  flex-basis: 0;
  flex-grow: 1;
  position: relative;
  overflow-y: hidden;
  overflow-y:scroll;
}

.filter-bar-wrapper {
  height: 40px;
  margin-top: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-family: Sans-serif;
  .filter-row {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 600;
    .label {
      margin-right: 1rem;
    }
    .value {
      cursor: pointer;
    }
  }
}


::v-deep .van-radio__icon--checked .van-icon {
    background-color: #196c44 !important;
    border-color: #196c44 !important;
}

::v-deep .van-radio-group{
  padding:0 1rem 1rem 1rem;
}
::v-deep .van-radio-group .van-radio {
    margin-top: 10px;
}



</style>
